import * as React from 'react';
import { connect } from 'react-redux';
import KPDropdown from '../../SSPCustomComponentLibrary/KPDropdown/KPDropdown';
import './LookupsSubmit.css';
import { getVehicleTypes, getAllRiskStolenLocations, getVehicleForcedEntryTypes, submitBlingClaim, setFnolReducerPayload, setFnolReducer } from '../../../../actions/claimSubmitActions';
import { IDropdownData } from '../../../../interfaces/KPDropdown/KPDropdownInterfaces';

class LookupsSubmit extends React.Component<any, any>  {
    constructor(props) {
        super(props);
        this.whichDropDownToDisplay = this.whichDropDownToDisplay.bind(this);
        this.handleVehicleSelection = this.handleVehicleSelection.bind(this);
        this.handleLocationSelection = this.handleLocationSelection.bind(this);
        this.handleEntrySelection = this.handleEntrySelection.bind(this);
        this.handleSubmitBlingClaim = this.handleSubmitBlingClaim.bind(this);

        this.state = { showNextDropdowns: false, entrySelection: null, locationSelection: null, vehicleSelection:null ,reRender:true};
    }

    async componentDidMount() {
        this.props.dispatchGetVehicleTypes();
        this.props.dispatchGetVehicleForcedEntryTypes();
    }

    handleSubmitBlingClaim() {
        this.props.dispatchAction(setFnolReducerPayload({ contactPersonFullName: "asdasd", contactPersonNumber: "0898899876", incidentDate: "2022-09-08T12:00:00", incidentEventType: { id: 41, description: "asdsafsd" }, isRepaired:null}));
        this.props.dispatchAction(setFnolReducer("isResponsiblePersonMemberOfHousehold",false));
        this.props.dispatchAction(setFnolReducerPayload({responsiblePersonFullName: "Test",responsiblePersonContactNumber: "0732565963"}));
        this.props.dispatchAction(setFnolReducerPayload({deliveryLocationLatitude:-25.790787,deliveryLocationLongitude:28.2784186}));
        this.props.dispatchAction(submitBlingClaim());
    }

    async handleEntrySelection(e: any) {
        var dropdownSelected = this.props.claimSubmit.forcedEntryType.find(x => x.id == Number(e))

        this.setState({ 
            entrySelection: dropdownSelected
        });
    }
   async handleLocationSelection(e: any) {
       var dropdownSelected = this.props.claimSubmit.stolenLocations.find(x => x.id == Number(e));
     
       this.setState({
           locationSelection: dropdownSelected
       });
    }

    async handleVehicleSelection(e: any) {

        await this.setState({
            reRender: false
        });

        var dropdownSelected = Number(e); 
        this.props.dispatchGetAllRiskStolenLocations(dropdownSelected);
       
            await this.setState({
                vehicleSelection: dropdownSelected, showNextDropdowns: true, locationSelection: null
            });

         await this.setState({
             reRender: true
         });
    }

    async whichDropDownToDisplay(whichViewToDisplay) {
        await this.setState({ dropDownView: false, showStylingFoundationSteps: false });
        await this.setState({ dropDownView: whichViewToDisplay });
        if (whichViewToDisplay === "styling-steps") {
            await this.setState({ showStylingFoundationSteps: true });
        }
    }

    public render() {
        let vehicleTypes = this.props.claimSubmit.claimVehicleTypes;
        let stolenLocations = this.props.claimSubmit.stolenLocations;
        let forcedEntryType = this.props.claimSubmit.forcedEntryType;
        
        let vehicleDropdown = [] as Array<IDropdownData>;
        let locationDropdown = [] as Array<IDropdownData>;
        let entryDropdown = [] as Array<IDropdownData>;

        if (vehicleTypes.length > 0) {
            vehicleDropdown = this.props.claimSubmit.claimVehicleTypes.map((item) => {
                var tempDropdown: IDropdownData = {
                    description: item.description,
                    id: String(item.id),
                    image: "",
                    productName: ""
                };
                return tempDropdown;
            });
        }

        if (stolenLocations.length > 0) {
            locationDropdown = this.props.claimSubmit.stolenLocations.map((item) => {
                var tempDropdown: IDropdownData = {
                    description: item.description,
                    id: String(item.id),
                    image: "",
                    productName: ""
                };
                return tempDropdown;
            });
        }
        
        if (forcedEntryType.length > 0) {
            entryDropdown = this.props.claimSubmit.forcedEntryType.map((item) => {
                var tempDropdown: IDropdownData = {
                    description: item.description,
                    id: String(item.id),
                    image: "",
                    productName: ""
                };
                return tempDropdown;
            });
        }

        return (
            <div id="appContainer" className="noProfile styling-project">

                <div className="align-center text-center mt-60px">
                    <span className="styling-foundation-page-header">
                        Styling Foundation:
                        <br />
                       Cellphone claims Lookups and Submit
                    </span>
                    <br />
                    <b>What type of car was it?</b>
                    <br />
                    <div className="col-12" title="SSP List Dropdown">
                        <div className="ssp-form">
                            <div className="form-group mb-0px">
                                <KPDropdown id={"claim-driver-dropdwon"}
                                    isImageDropdown={false}
                                    showLabelAfterSelection={true}
                                    showLabelInside={true}
                                    showLabelOutside={false}
                                    isRiskItem={false}
                                    labelAfterSelection={"What type of car was it"}
                                    title={"What type of car was it"}
                                    label={"What type of car was it"}
                                    data={vehicleDropdown}
                                    handleSelection={(e) => this.handleVehicleSelection(e)}
                                    selectedValue={vehicleDropdown.find(x => x.id == String(this.props.claimSubmit.claimVehicleTypes))} />
                            </div>
                        </div>
                    </div>

                    {this.state.showNextDropdowns && this.state.reRender &&
                        <>
                        <br />
                        <b>Where was the phone when it was stolen?</b>
                        <br />
                        <div className="col-12" title="SSP List Dropdown">
                            <div className="ssp-form">
                                <div className="form-group mb-0px">
                                    <KPDropdown id={"claim-driver-dropdwon"}
                                        isImageDropdown={false}
                                        showLabelAfterSelection={true}
                                        showLabelInside={true}
                                        showLabelOutside={false}
                                        isRiskItem={false}
                                        labelAfterSelection={"Where was the phone when it was stolen?"}
                                        title={"Where was the phone when it was stolen?"}
                                        label={"Where was the phone when it was stolen?"}
                                        data={locationDropdown}
                                        handleSelection={(e) => this.handleLocationSelection(e)}
                                        selectedValue={this.state.locationSelection} />
                                </div>
                            </div>
                        </div>
                        <br />
                        <b>How was entry gained?</b>
                        <br />
                        <br />
                        <div className="col-12" title="SSP List Dropdown">
                            <div className="ssp-form">
                                <div className="form-group mb-0px">
                                    <KPDropdown id={"claim-driver-dropdwon"}
                                        isImageDropdown={false}
                                        showLabelAfterSelection={true}
                                        showLabelInside={true}
                                        showLabelOutside={false}
                                        isRiskItem={false}
                                        labelAfterSelection={"How was entry gained?"}
                                        title={"How was entry gained?"}
                                        label={"How was entry gained?"}
                                        data={entryDropdown}
                                        handleSelection={(e) => this.handleEntrySelection(e)}
                                        selectedValue={vehicleDropdown.find(x => x.id == String(this.props.claimSubmit.entryDropdown))} />
                                </div>
                            </div>
                        </div>
                        <b>Submit Claim</b>
                        <br />
                        <input type="button" onClick={this.handleSubmitBlingClaim} value="Submit Bling Claim" />
                        </>
                    }
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        claimSubmit: state.claimSubmit,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchGetVehicleTypes:() => dispatch(getVehicleTypes()),
        dispatchGetAllRiskStolenLocations: (vehicletypeid) => dispatch(getAllRiskStolenLocations(vehicletypeid)),
        dispatchGetVehicleForcedEntryTypes: () => dispatch(getVehicleForcedEntryTypes()),
        dispatchAction: (e) => dispatch(e),
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(LookupsSubmit)